function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { COHORT_METRIC_ENTRY_DEFAULT_PROPS } from 'common/report/util/cohorts/transformations/entries';
import { emitTrackEvent } from 'common/util/dom';
import { IncludeCustomPropertyType } from 'common/query-builder/query-block/properties-menu/types';
import { isCompanyProfileEnabled } from 'common/report/util/feature-sampling';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { CurrentProjectResource } from 'common/report/model-resources/projects';
import { QueryBuilderUpdateDetail } from '../query-builder/types';
import { CohortGroupEntry, RowLabelType, RowTypeComplexOption, SelectorTypeDefinitions } from '../query-entry-section/types';
import { QueryBuilderReact } from '../query-builder';
import { AGGREGATE_USER_FREQ_BY_GROUP, FIRST_EVENT_TIME_PROPERTY } from '../query-block/properties-menu/constants';
import { Cohort } from './models/cohort';
import { SerializedCohort } from './models/types/serialized-cohort-types';
import { StagedCohort } from './models/builder/staged-cohort';
import { SerializedStagedCohort } from './models/types/serialized-staged-cohort-types';
import { CohortsQueryBuilderUpdate } from './types';
interface CohortsQueryBuilderJsxProps {
  elref?: string;
  cohort?: SerializedCohort;
  /** @todo [pablo] drop this to remove backwards compatibility with site calls using staged-cohort */
  // the serialized cohort you want this builder to render
  stagedCohort?: SerializedStagedCohort;
  projectId: number;
  projectHasCohorts?: boolean;
  dataGroupId?: string;
  supportB2bCohorts?: boolean;
  disabled?: boolean;
  trackName?: string;
  userId?: number;
  workspaceId?: number;
  projectAsOfDate?: string;
  maxDataHistoryDays?: string;
  projectHasPeople?: boolean;
  hideResetButton?: boolean;
  nonCollapsible: boolean;
  hideEditControls?: boolean;
  querySource?: string;
  headerTitle?: string;
  footerItems?: React.ReactNode;
  onCohortUpdate?: (update: CohortsQueryBuilderUpdate) => void;
  onTrack?: (trackedEvent: {
    eventName: string;
    props: {
      [key: string]: any;
    };
  }) => void;
  currentProject: CurrentProjectResource;
}
type CohortsQueryBuilderState = EmptyObj;
class CohortsQueryBuilder extends React.PureComponent<CohortsQueryBuilderJsxProps, CohortsQueryBuilderState> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "divRef", React.createRef<HTMLDivElement>());
  }
  hasPeopleEnabled() {
    var _this$props$currentPr;
    return (_this$props$currentPr = this.props.currentProject.get().value) === null || _this$props$currentPr === void 0 ? void 0 : _this$props$currentPr.hasIntegratedEngage;
  }
  getProjectAsOfDate() {
    var _this$props$currentPr2, _this$props$currentPr3;
    return (_this$props$currentPr2 = (_this$props$currentPr3 = this.props.currentProject.get().value) === null || _this$props$currentPr3 === void 0 ? void 0 : _this$props$currentPr3.projectAsOfDate) !== null && _this$props$currentPr2 !== void 0 ? _this$props$currentPr2 : "";
  }
  get cohort() {
    var _this$props$cohort;
    const defaultCohort = Cohort.createCohortFromStaged(StagedCohort.deserialize(null)).serialize();
    return Cohort.parseCohort((_this$props$cohort = this.props.cohort) !== null && _this$props$cohort !== void 0 ? _this$props$cohort : defaultCohort);
  }
  get rowTypes(): RowTypeComplexOption[] {
    return [{
      value: SelectorTypeDefinitions.CohortGroup,
      placeholderEntry: {
        event: COHORT_METRIC_ENTRY_DEFAULT_PROPS.event
      }
    }];
  }

  /**
   * Updates the selected cohort with the updated groups from the qb
   */
  handleQueryUpdate(detail: QueryBuilderUpdateDetail) {
    var _this$props$onCohortU, _this$props;
    let cohort = this.cohort;
    cohort.groups = detail.entries as CohortGroupEntry[];

    // prevent an empty cohort definition from being constructed
    if (cohort.groups.length === 0) {
      cohort = new Cohort({
        dataGroupId: this.props.dataGroupId
      });
    }
    (_this$props$onCohortU = (_this$props = this.props).onCohortUpdate) === null || _this$props$onCohortU === void 0 || _this$props$onCohortU.call(_this$props, {
      cohort,
      queryReason: detail.queryReason
    });
    this.trackUpdate(cohort);
  }
  trackUpdate(cohort: Cohort) {
    const trackingEvent = {
      eventName: "[Cohorts] Update cohort",
      props: _objectSpread(_objectSpread({}, cohort.toTrackingData()), this.props.querySource ? {
        'Query Source': this.props.querySource
      } : {})
    };
    if (this.props.onTrack) {
      this.props.onTrack(trackingEvent);
    } else {
      emitTrackEvent(this.divRef.current, trackingEvent);
    }
  }
  render() {
    var _this$cohort$dataGrou;
    return <div ref={this.divRef} data-sentry-component="CohortsQueryBuilder" data-sentry-source-file="index.tsx">
        <QueryBuilderReact elref='cohortQueryBuilder' contained entries={this.cohort.groups} addEntryButtonLabel={_ref => {
        let {
          t
        } = _ref;
        return t("filters.group");
      }} otherFilterOptions={[FIRST_EVENT_TIME_PROPERTY, ...(this.cohort.dataGroupId && isCompanyProfileEnabled(this.props.currentProject.get().value) ? [AGGREGATE_USER_FREQ_BY_GROUP] : [])]}
      // allows for per-line cohort filters as Insights does
      allowCohortFilter entryRowLabelType={RowLabelType.None} entriesDraggable includeCustomProperties={IncludeCustomPropertyType.All} showBorrowedProperties showAnyEvent showSessions mainEntryNonCollapsible={this.props.nonCollapsible} rowLimit={26}
      /** disables new group on empty state */ disableAddEntry={this.cohort.groups.length === 1 && this.cohort.groups[0].filters.length === 0}
      /**
       * @todo [pablo] figure out how to slot in save controls content from this project:
       * https://www.notion.so/mpspeed/Design-proposal-v2-e04e0ec0edad422899eaee6372f195f3
       * */ headerTitle={this.props.headerTitle} headerTitleLowercase hideDatePicker hideEditControls={this.props.hideEditControls} hideFilter hideGroupBy behaviorMode
      /** @todo [pablo] enable this and have b2b validation be entirely owned by the query builder */ hideDataGroupsSelector allDataGroups dataGroupId={(_this$cohort$dataGrou = this.cohort.dataGroupId) !== null && _this$cohort$dataGrou !== void 0 ? _this$cohort$dataGrou : ""} dataGroupsEnabled={this.props.supportB2bCohorts} maxDataHistoryDays={+this.props.maxDataHistoryDays} rowTypes={this.rowTypes} supportB2bCohorts={this.props.supportB2bCohorts} projectHasCohorts={this.props.projectHasCohorts} inlineCohortsOverride={{
        enable: false
      }} trackName={"cohorts"} projectHasPeople={this.hasPeopleEnabled()} projectAsOfDate={this.getProjectAsOfDate()} projectId={this.props.projectId} workspaceId={this.props.workspaceId} userId={this.props.userId} footerItems={this.props.footerItems} onUpdate={detail => this.handleQueryUpdate(detail)} data-sentry-element="QueryBuilderReact" data-sentry-source-file="index.tsx" />
      </div>;
  }
}
export const CohortsBuilderReact = (props: Omit<CohortsQueryBuilderJsxProps, `currentProject`>) => {
  const currentProject = useCurrentProject();
  return <CohortsQueryBuilder {...props} currentProject={currentProject} data-sentry-element="CohortsQueryBuilder" data-sentry-component="CohortsBuilderReact" data-sentry-source-file="index.tsx" />;
};